export default "__VITE_ASSET__GymCz8cJ__"